import { createSlice } from "@reduxjs/toolkit";
import { startTransition } from "react";
export const assignToBranchSlice = createSlice({
	name: "assignToBranch",
	initialState: {
		searchData: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
			lockerTypeId: "-1",
			partnerId: "-1",
		},
		assignedBranchLockerData: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
			lockerId: [],
			partnerBranchId: "-1",
		},
		lockerTypeList: [],
		partnerList: [],
		brachesLockerAssignmentData: [],
		unassignedLockerList: [],
		unassignedBranchList: [],
	},
	reducers: {
		getPartnerList: (state, actions) => {
			state.partnerList = actions.payload;
		},
		getLockerTypeList: (state, actions) => {
			state.lockerTypeList = actions.payload;
		},
		getUnassignedLockerList: (state, actions) => {
			state.unassignedLockerList = actions.payload;
		},
		getUnassignedBranchList: (state, actions) => {
			state.unassignedBranchList = actions.payload;
		},
		getBrachesLockerAssignmentData: (state, actions) => {
			state.brachesLockerAssignmentData = actions.payload;
		},
		handleAssignedBranchLockerData: (state, actions) => {
			const { name, value } = actions.payload;
			switch (name) {
				case "lockerId":
					return {
						...state,
						assignedBranchLockerData: {
							...state.assignedBranchLockerData,
							lockerId: value,
						},
					};

				case "partnerBranchId":
					return {
						...state,
						assignedBranchLockerData: {
							...state.assignedBranchLockerData,
							partnerBranchId: value,
						},
					};
			}
		},
		handleOnChanged: (state, actions) => {
			const { name, value } = actions.payload;
			switch (name) {
				case "lockerTypeId":
					return {
						...state,
						searchData: {
							...state.searchData,
							lockerTypeId: value,
						},
					};
				case "partnerId":
					return {
						...state,
						searchData: {
							...state.searchData,
							partnerId: value,
						},
					};
				default:
					break;
			}
		},
		clearBrachesLockerAssignmentData: (state, actions) => {
			state.brachesLockerAssignmentData = [];
		},
		clearSearchData: (state) => {
			state.searchData = {
				operatorId: localStorage.getItem("user")
					? JSON.parse(localStorage.getItem("user")).operator_id
					: "",
				lockerTypeId: "-1",
				partnerId: "-1",
			};
			state.assignedBranchLockerData = {
				operatorId: localStorage.getItem("user")
					? JSON.parse(localStorage.getItem("user")).operator_id
					: "",
				lockerId: "-1",
				partnerBranchId: "-1",
			};
			// state.lockerTypeList = [];
			// state.partnerList = [];
			state.brachesLockerAssignmentData = [];
			state.unassignedLockerList = [];
			state.unassignedBranchList = [];
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	getPartnerList,
	getLockerTypeList,
	getUnassignedLockerList,
	getUnassignedBranchList,
	getBrachesLockerAssignmentData,
	handleOnChanged,
	clearBrachesLockerAssignmentData,
	clearSearchData,
	handleAssignedBranchLockerData,
} = assignToBranchSlice.actions;

export default assignToBranchSlice.reducer;
